import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=60c59ad2&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=60c59ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c59ad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c59ad2')) {
      api.createRecord('60c59ad2', component.options)
    } else {
      api.reload('60c59ad2', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=60c59ad2&scoped=true&", function () {
      api.rerender('60c59ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20nwwJrD5W0lr/JS/comp/SearchFilterTokens.vue"
export default component.exports